// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 66) return "js/66.js";
	if (chunkId === 802) return "js/802.js";
	if (chunkId === 896) return "js/896.js";
	// return url for filenames based on template
	return undefined;
};